import type { Options } from 'api/core/base';
import { makeRequest } from 'api/core/base';

export const Get = (url: string, options: Options = {}) => {
  return makeRequest(url, 'get', null, options);
};

export const Delete = (url: string, data: any = undefined, options: Options = {}) => {
  const jsonData = data ? JSON.stringify(data) : null;
  return makeRequest(url, 'delete', jsonData, options);
};

export const Put = (url: string, data: any = undefined, options: Options = {}) => {
  const jsonData = JSON.stringify(data);
  return makeRequest(url, 'put', jsonData, options);
};

export const Post = (url: string, data: any = undefined, options: Options = {}) => {
  const jsonData = JSON.stringify(data);
  return makeRequest(url, 'post', jsonData, options);
};

export const Patch = (url: string, data: any = undefined, options: Options = {}) => {
  const jsonData = JSON.stringify(data);
  return makeRequest(url, 'PATCH', jsonData, options);
};

export const Download = (url: string, data: any = undefined, options: Options = {}) => {
  const method = data ? 'post' : 'get';
  const jsonData = data ? JSON.stringify(data) : null;
  return makeRequest(url, method, jsonData, { ...options, isFile: true });
};
